import React from "react";
import { Mail, MessageCircle } from "lucide-react";
import SEO from "../components/SEO";
import { useLanguage } from "../context/LanguageContext";

export default function Support() {
    const { t } = useLanguage();

    return (
        <div className="min-h-screen bg-spiritual-white dark:bg-gray-950 flex items-center justify-center p-6 font-body">
            <SEO 
              title={t("support_title")} 
              description={t("support_desc")} 
              url="/support" 
            />

            <div className="max-w-md w-full text-center space-y-8">

                <div className="w-20 h-20 bg-blue-50 dark:bg-gray-800 rounded-full flex items-center justify-center mx-auto text-brand-blue">
                    <MessageCircle className="w-10 h-10" />
                </div>

                <div className="space-y-4">
                    <h1 className="text-3xl font-display font-medium text-gray-900 dark:text-white">
                        {t("support_title")}
                    </h1>
                    <p className="text-gray-500 dark:text-gray-400 leading-relaxed">
                        {t("support_desc")}
                    </p>
                </div>

                <div className="p-6 bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700">
                    <p className="text-sm uppercase tracking-widest text-gray-400 font-medium mb-4">{t("support_contact_title")}</p>
                    <a
                        href="mailto:support@antaryatra-app.com"
                        className="flex items-center justify-center gap-3 text-xl font-semibold text-brand-blue hover:underline"
                    >
                        <Mail className="w-5 h-5" />
                        support@antaryatra-app.com
                    </a>
                    <p className="text-xs text-gray-400 mt-4">
                        {t("support_reply_time")}
                    </p>
                </div>

            </div>
        </div>
    );
}
